import classNames from 'classnames';

export const priceModeOptions = Object.freeze({
  both: 'Show MSRP and D. NET prices',
  msrpOnly: 'Show MSRP prices only',
  dNetOnly: 'Show D. NET prices only',
});

export function getDefaultPriceMode() {
  return window.innerWidth <= 760 ? 'dNetOnly' : 'both';
}

export function getMsrpColumnClassNames(priceMode) {
  return classNames(
    'text-end',
    {
      show: priceMode !== 'dNetOnly',
      hide: priceMode === 'dNetOnly',
    },
    {
      'col-3': priceMode === 'both',
      'col-6': priceMode === 'msrpOnly',
    }
  );
}

export function getDNetColumnClassNames(priceMode) {
  return classNames(
    'text-end',
    {
      show: priceMode !== 'msrpOnly',
      hide: priceMode === 'msrpOnly',
    },
    {
      'col-3': priceMode === 'both',
      'col-6': priceMode === 'dNetOnly',
    }
  );
}

export function getTotalMsrpColumnClassNames(priceMode) {
  return classNames(
    'text-end',
    {
      show: priceMode !== 'dNetOnly',
      hide: priceMode === 'dNetOnly',
    },
    {
      'col-3': priceMode === 'both',
      'col-6': priceMode === 'msrpOnly',
    }
  );
}

export function getTotalDNetColumnClassNames(priceMode) {
  return classNames(
    'text-end',
    {
      show: priceMode !== 'msrpOnly',
      hide: priceMode === 'msrpOnly',
    },
    {
      'col-3': priceMode === 'both',
      'col-6': priceMode === 'dNetOnly',
    }
  );
}
